// extracted by mini-css-extract-plugin
export default {"Loader-wrapper":"loader_Loader-wrapper__8Sv9r","loader":"loader_loader__MV3vo","Table":"loader_Table__t9MtJ"};